import React, { Component } from "react";
import { connect } from "react-redux";
// import { bindActionCreators } from "redux";
import validator from "validator";
// import google from '../../../assests/images/google.png';
// import facebook from '../../../assests/images/facebook.png';
import ContentWrapper from "../../../common/components/contentWrapper";
import VisibilityIcon from '@material-ui/icons/Visibility';
import { InputAdornment, Select, MenuItem } from '@material-ui/core';
import getUserdetailsforsubscrption from '../../pages/dashboard/actions/dashboardaapi'
import ReactivateAccountModal from "../../../common/components/ReactivateAccountModal";

import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import AllInboxIcon from "@material-ui/icons/AllInbox";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import LinkIcon from "@material-ui/icons/Link";
import BarChartIcon from "@material-ui/icons/BarChart";
import {
  FormControl,
  FormHelperText,
  Link,
  Input,
  Button,
} from "@material-ui/core";
import "../../../common/style/main.css";
// import paths from './../../../utils/paths'
import { login, fetchRss } from "./../reducer/actions";
// import SocialButton from "./socialButtonLogin";
import { toast } from "react-toastify";
// import { SignalCellularNullOutlined } from "@material-ui/icons";
// import { escape, keyBy } from "lodash";
import { formatDate } from "../../../common/components/Helper/Utils";
import { createlabelSetting } from "./../../pages/administration/actions/administration";
import loginBg from "../../../assests/images/login/login-watch.png";
import "../../Auth/login/style/login.css";

const Loader = () => (
  <div className="loginLoader"></div>
);

class LogInComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'password',
      score: 'null',
      emailId: "",
      password: "",
      emailIdErrorText: "",
      passwordErrorText: "",
      isValid: false,
      open: false,
      userId: '',
      email: '',
      component: 'LOGIN',
      deletedDate: '',
      isLoading: false
    };
    this.showHide = this.showHide.bind(this);
    this.passwordStrength = this.passwordStrength.bind(this);
    this.onEmailIdChange = this.onEmailIdChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.signin = this.signin.bind(this);
    this.handleSocialLogin = this.handleSocialLogin.bind(this);
    this.handleSocialLoginFailure = this.handleSocialLoginFailure.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    localStorage.removeItem("token");
    window.sessionStorage.removeItem("token");
    window.sessionStorage.removeItem("userDetails");
  }

  handleSocialLogin = (user) => {
    let data = {};
    let loginData = {};
    switch (user._provider) {
      case "google":
        data = {
          first_name: user._profile.firstName,
          last_name: user._profile.lastName,
          email: user._profile.email,
          phone: '',
          source: user._provider,
          source_id: user._profile.id,
          photo_url: user._profile.profilePicURL,
        };
        break;
      case "facebook":
        data = {
          first_name: user._profile.first_name,
          last_name: user._profile.last_name,
          email: user._profile.email,
          phone: '',
          source: user._provider,
          source_id: user._profile.id,
          photo_url: user._profile.profilePicURL,
        };
        break;
    }

    const { loginRequested, loginSuccess, loginFailed, history } = this.props;

    loginRequested(null);
    loginData = {
      email: data.email,
      source: data.source,
      source_id: data.source_id,
    };

    login(
      loginData,
      (res) => {
        if (res.success === 1) {
          toast("User Login successfully", {
            autoClose: 5000,
            type: toast.TYPE.SUCCESS,
            position: toast.POSITION.BOTTOM_CENTER,
          });
          loginSuccess(res);
          // history.push("/add-to-inventory-search");
          this.checkbunicessdetails(res.data.userid)
          // history.push("/register");

        }
        // else if(res.success === 0 && res.deletedAccount && res.deletedAccount.keepThisAccount){
        //     this.setState({
        //       open:true,
        //       userId: res.deletedAccount?.userId || null,
        //       email: res.deletedAccount.email
        //     })
        //  }
        else {
          this.props.setUserDeatils(data);
          // history.push("/verify-email");
          toast("Invalid email or password", {
            autoClose: 5000,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }

      },
      (error) => {
        loginFailed(error);
        toast("Please check your credentials.", {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    );
  };

  handleSocialLoginFailure = (err) => {
    console.error(err)
  }

  validateInput() {
    let emailIdErrorText = "";
    let passwordErrorText = "";
    const emailId = (this.state.emailId || "").trim();

    let isValid = true;
    if (!emailId) {
      emailIdErrorText = "Please enter Email address";
      isValid = false;
    } else if (!validator.isEmail(emailId)) {
      emailIdErrorText = "Enter Valid Email Id";
      isValid = false;
    }
    if (this.state.password.length === 0) {
      passwordErrorText = "Please enter Password";
      isValid = false;
    }
    this.setState({ emailId, emailIdErrorText, passwordErrorText });
    return isValid;
  }

  onEmailIdChange(event) {
    const rawValue = event.target.value;
    const emailId = (rawValue || "").trim();
    if (!emailId) {
      this.setState({
        emailId: "",
        emailIdErrorText: "",
        isValid: false,
      });
      return;
    }
    if (!validator.isEmail(emailId)) {
      this.setState({
        emailId,
        emailIdErrorText: "Enter Valid Email Id",
        isValid: false,
      });
      return;
    }
      this.setState({
        emailId,
        emailIdErrorText: "",
        isValid: true,
      });
  }

  onPasswordChange = (event) => {
    let passwordVal = event.target.value;
    if (!passwordVal) {
      this.setState({
        password: "",
        passwordErrorText: "",
        isValid: false
      })
    }
    else {
      this.setState({
        passwordErrorText: "",
        password: event.target.value,
        isValid: true
      })
    }
  }

  showHide(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      type: this.state.type === 'input' ? 'password' : 'input'
    })
  }

  passwordStrength(e) {
    if (e.target.value === '') {
      this.setState({
        score: 'null'
      })
    }
    else {
      let pw = e.target.value;
      this.setState({
        score: pw.score
      });
    }
  }

  signin() {
    const { loginRequested, loginSuccess, loginFailed, history } = this.props;
    if (!this.validateInput()) {
      return;
    }
    const apiInput = {
      email: this.state.emailId,
      password: this.state.password,
    };
    this.setState({ isLoading: true });
    loginRequested(null);
    login(
      apiInput,
      (res) => {
        this.setState({ isLoading: false });
        if (res.success === 1) {
          loginSuccess(res);
          if (res.data.userid) {
            // this.checkbunicessdetails(res.data.userid)
            const loginDetails = res.data
            window.sessionStorage.setItem('isShopifyEnabled', loginDetails.is_shopifyenabled);
            window.sessionStorage.setItem('isQboEnabled', loginDetails.is_qboenabled);
            window.sessionStorage.setItem('isShopifyVerified', loginDetails.is_shopifyverified);
            window.sessionStorage.setItem('isQboVerified', loginDetails.qbo_isverified);
            window.sessionStorage.setItem('isApiExposed', loginDetails.is_apiexposed);
            window.sessionStorage.setItem('isEbayEnabled', loginDetails.is_ebayenabled);
            window.sessionStorage.setItem('isEbayVerified', loginDetails.is_ebayverified);
            // window.sessionStorage.setItem("AccountId", res.data.accountid);
            getUserdetailsforsubscrption.getUserDetails(res.data.userid).then((response) => {
              this.setState({
                userdetailsforsubcplan: response.data.data
              });
              // if (res.data?.roleid == 2 && (res.data?.plandetails === "Noplan" || res.data?.plandetails === null)) {
              if ((!res.data?.plandetails || res.data?.plandetails === "Noplan")
                && (res.data?.dealerinventory_plan && res.data?.dealerinventory_plan !== 'no_subscription')) {
                localStorage.setItem("menuTitle", "DEALER INVENTORY");
                this.props.history.push("/dealerinventory");
                toast("User logged in successfully", {
                  autoClose: 5000,
                  type: toast.TYPE.SUCCESS,
                  position: toast.POSITION.BOTTOM_CENTER,
                });
              }
              else if (response.data.data.businessname === null || response.data.data.businessname === "undefined") {
                // history.push("/");
                window.location.href = '/register';
              }
              //Comment on Jan 25 
              // else if(loginDetails?.membertier_id && loginDetails?.membertier_id === 1 ){
              //   // this.props.history.push("/dealernew");
              //   toast("User Logged In Successfully", {
              //     autoClose: 5000,
              //     type: toast.TYPE.SUCCESS,
              //     position: toast.POSITION.BOTTOM_CENTER,
              //   });

              // }
              else {
                const accountDetails = JSON.parse(window.sessionStorage.getItem('userDetails')).accountdetails
                const activeAccount = accountDetails.find(account => account?.isprimary === true);
                if (activeAccount?.accountid) {
                  window.sessionStorage.setItem('accountId', activeAccount?.accountid)
                }
                else {
                  window.sessionStorage.setItem('accountId', accountDetails[0]?.accountid)
                }
                try {
                  createlabelSetting((err, res) => {
                    if (err) return;

                    if (res && res.data) {
                      sessionStorage.setItem(
                        "customLabelSettings",
                        JSON.stringify(res.data)
                      );
                    }
                  });
                } catch (e) {
                  console.error(e);
                }
                const mfaData = {
                  is_mfa_enabled: res.data?.is_mfa_enabled,
                  is_remindme_later: res.data?.is_remindme_later,
                  mfa_enabled_status: res.data?.mfa_enabled_status,
                  mfa_channel: res.data?.mfa_channel,
                  remindme_date: res.data?.remindme_date
                };

                if (
                  (mfaData.is_mfa_enabled == null) &&
                  (mfaData.is_remindme_later == null) &&
                  (mfaData.mfa_enabled_status == null) &&
                  mfaData.mfa_channel == null
                ) {
                  this.props.history.push("/mfa");
                  return;
                }
                if (
                  mfaData.is_mfa_enabled === true &&
                  (mfaData.mfa_channel === "email" || mfaData.mfa_channel === "phone") &&
                  mfaData.is_remindme_later === false
                ) {
                  sessionStorage.setItem("mfaData", JSON.stringify({
                    userId: res.userId,
                    channel: mfaData.mfa_channel,
                    email: res.email,
                    countryCode: res.countryCode,
                    phone: res.phone,
                  }));
                  // console.log("resss", res);
                  toast("OTP sent successfully", {
                    autoClose: 3000,
                    type: toast.TYPE.SUCCESS,
                    position: toast.POSITION.BOTTOM_CENTER,
                  });

                  this.props.history.push({
                    pathname: "/mfa-otp-verify",
                    state: { method: res.channel }
                  });
                  return;
                }

                if (
                  mfaData.is_mfa_enabled === false &&
                  mfaData.is_remindme_later === true &&
                  mfaData.mfa_enabled_status === "remindmelater"
                ) {
                  const expiry = mfaData.remindme_date;
                  if (!expiry) {
                    this.props.history.push("/mfa");
                    return;
                  }

                  const now = new Date().getTime();
                  const expiryTime = new Date(expiry).getTime();

                  if (!isNaN(expiryTime) && now < expiryTime) {
                    this.props.history.push("/search");
                    return;
                  }

                  this.props.history.push("/mfa");
                  return;
                }
                if (
                  mfaData.is_mfa_enabled === false &&
                  mfaData.is_remindme_later === false &&
                  mfaData.mfa_enabled_status === "notNow"
                ) {
                  this.props.history.push("/search");
                  return;
                }

                if (
                  mfaData.is_mfa_enabled === false &&
                  mfaData.is_remindme_later === false &&
                  mfaData.mfa_enabled_status === "enabled" &&
                  (mfaData.mfa_channel === "email" || mfaData.mfa_channel === "phone")
                ) {
                  this.props.history.push("/search");
                  return;
                }
                if (
                  (mfaData.is_mfa_enabled === false) &&
                  (mfaData.is_remindme_later === false) &&
                  (mfaData.mfa_enabled_status == null) &&
                  mfaData.mfa_channel == null
                ) {
                  this.props.history.push("/search");
                  return;
                }

                this.props.history.push("/search");
                toast("User logged in successfully", {
                  autoClose: 5000,
                  type: toast.TYPE.SUCCESS,
                  position: toast.POSITION.BOTTOM_CENTER,
                });
              }
            })
          }
          // history.push("/register");
        }
        else if (res.success === 0 && res.deletedAccount && res.deletedAccount.keepThisAccount) {
          let date = res.deletedAccount.deletedDate;
          // let currentDate = moment(date, "YYYY-MM-DD");
          let currentDate = formatDate(date, "YYYY-MM-DD");
          currentDate.add(1, 'month')
          this.setState({
            open: true,
            userId: res.deletedAccount.userId,
            email: res.deletedAccount.email,
            deletedDate: currentDate.format("YYYY-MM-DD")
          })
          //   toast("Your Account can be activated.Please Login again", {
          //     autoClose: 5000,
          //     type: toast.TYPE.SUCCESS,
          //     position: toast.POSITION.BOTTOM_CENTER,
          // });
        }
        else {
          loginFailed(res);
          this.setState({
            passwordErrorText: "",
            emailIdErrorText: "",
          });
          toast("Please Check Your Credentials.", {
            autoClose: 5000,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      },
      (error) => {
        this.setState({
          isLoading: false,
          passwordErrorText: "",
          emailIdErrorText: "", });
        loginFailed(error);
        toast("Please Check Your Credentials.", {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    );
  }

  handleClose() {
    this.setState({
      open: false
    })
  }

  getContentView() {
    const { type, emailIdErrorText, passwordErrorText, isLoading } = this.state;
    return (
      <div className="lg-page">
        <main className="lg-main" style={{ ["--lg-hero-bg"]: `url(${loginBg})` }}
        >
          <div className="lg-hero-bg" aria-hidden="true" />
          <div className="lg-hero-shade" aria-hidden="true" />

          <img
            src={loginBg}
            alt=""
            className="lg-watch-focal"
            aria-hidden="true"
          />

          <section className="lg-left">
            <div className="lg-left-content">
              <div className="lg-copy-block">
            <span className="lg-eyebrow">Built by dealers, for dealers</span>
            <h1 className="lg-title">
                  <span className="lg-title-line">The Smarter Way to Run Your Watch Business.</span>
                  {/* <span className="lg-title-accent">A Safer Tomorrow.</span> */}
                </h1>
            <p className="lg-sub">
                WatchOps simplifies your day-to-day so you can focus on closing deals, not chasing data.
                </p>

            <div className="lg-features">
              <div className="lg-feature">
                    <span><AllInboxIcon /></span>
                    <p>Inventory Management</p>
                  </div>
              <div className="lg-feature">
                    <span><DescriptionOutlinedIcon /></span>
                    <p>Invoice &amp; Payment Tracking</p>
                  </div>
                  <div className="lg-feature">
                    <span><LinkIcon /></span>
                    <p>Effortless Inventory Sharing</p>
                  </div>
              <div className="lg-feature">
                    <span><BarChartIcon /></span>
                    <p>Keep Track of Dealers & Customers</p>
                  </div>
                </div>
                </div>
            </div>
          </section>

          <section className="lg-right">
            <div className="lg-form">
              <h2 className="lg-form-title">Welcome</h2>
              <p className="lg-form-sub">Sign in to your WatchOps account to continue.</p>

              <form onSubmit={(e) => e.preventDefault()}>
                <label className="lg-label" htmlFor="lg-email">Email Address</label>
                <FormControl fullWidth>
                  <Input
                    id="lg-email"
                    className="lg-input"
                    disableUnderline
                    placeholder="Enter your email address"
                    startAdornment={<InputAdornment position="start"><MailOutlineIcon /></InputAdornment>}
                    onChange={this.onEmailIdChange}
                    onKeyDown={(event) => event.key === 'Enter' ? this.signin() : null}
                  />
                  <FormHelperText className="error-o">{emailIdErrorText}</FormHelperText>
                </FormControl>

                <label className="lg-label" htmlFor="lg-password">Password</label>
                <FormControl fullWidth>
                  <Input
                    id="lg-password"
                    className="lg-input"
                    disableUnderline
                    type={type}
                    placeholder="Enter your password"
                    startAdornment={<InputAdornment position="start"><LockOutlinedIcon /></InputAdornment>}
                    endAdornment={
                      <InputAdornment position="end">
                        <span onClick={this.showHide} className="lg-eye">
                          {type === 'input' ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </span>
                      </InputAdornment>
                    }
                    onChange={this.onPasswordChange}
                    onKeyDown={(event) => event.key === 'Enter' ? this.signin() : null}
                  />
                  <FormHelperText className="error-o">{passwordErrorText}</FormHelperText>
                </FormControl>

                <div className="lg-forgot"><Link href="/forgot-password">Forgot Password?</Link></div>

                <Button
                  className="lg-btn"
                  fullWidth
                  type="button"
                  onClick={this.signin}
                  disabled={isLoading}
                  style={{ opacity: isLoading ? '0.6' : '1' }}
                >
                  {isLoading ? (<>LOGIN <Loader /></>) : (<>LOGIN <ArrowForwardIcon /></>)}
                </Button>
              </form>

              <div className="lg-or"><span>OR</span></div>
              <p className="lg-signup">New to WatchOps?{" "} <Link href="/sign-up">Create an account</Link></p>
            </div>
          </section>
        </main>

        <ReactivateAccountModal open={this.state.open} handleClose={this.handleClose} deletedDate={this.state.deletedDate} data={{ ...this.state }} />
      </div>
    );
  }

  render() {
    return <ContentWrapper contentView={this.getContentView()} />;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    loginRequested: (payload) => dispatch({ type: "LOGIN_REQUESTED", payload }),
    loginSuccess: (payload) => dispatch({ type: "LOGIN_SUCCESS", payload }),
    loginFailed: (payload) => dispatch({ type: "LOGIN_FAILED", payload }),
    signUpRequested: (payload) => dispatch({ type: "SIGNUP_REQUESTED", payload }),
    signUpSuccess: (payload) => dispatch({ type: "SIGNUP_SUCCESS", payload }),
    signUpFailed: (payload) => dispatch({ type: "SIGNUP_FAILED", payload }),
    setUserDeatils: (payload) => dispatch({ type: "GET_USER_DETAILS_DATA_SUCCESS", payload }),
  };
}

export default connect(null, mapDispatchToProps)(LogInComponent);
